import {
  APP_NAME, CLOSE, GET_URL, LOGOUT, OKTA_AUTH, REQUEST_ACCESS_TOKEN, RETAIL_AUTH, SET_TITLE, NPOS_APP, TRUE_APP, APPLE_WEBKIT
} from './constants';

export const Messages = {
  Close: CLOSE,
  GetURL: GET_URL,
  Logout: LOGOUT,
  RequestAccessToken: REQUEST_ACCESS_TOKEN,
  SetTitle: SET_TITLE,
};

export const AppName = APP_NAME;

export const AuthTypes = {
  OktaAuth: OKTA_AUTH,
  RetailAuth: RETAIL_AUTH,
};

export const getTokenVersion = () => localStorage.getItem('tokenVersion');

export const getApplicationSource = () => sessionStorage.getItem('source');

export const getApplicationSourceName = () => getApplicationSource() || 'EJ web';

export const getApplicationAuthSource = () => localStorage.getItem('authSource');

export const isRetailLogin = () => {
  const applicationSource = getApplicationSource();
  return ([TRUE_APP, NPOS_APP].includes(applicationSource) && getApplicationAuthSource() === RETAIL_AUTH);
};

export const isRunningIframe = () => (window.location !== window.parent.location);

/**
 * This function determins whether the EJ is loaded inside the NPOS app (iOS Webkit).
 */
export const isRunningInsideNposApp = () => {
  const nav = window.navigator;
  const userAgent = nav && nav.userAgent;
  const isAppleWebKit = userAgent.includes(APPLE_WEBKIT);
  return (isAppleWebKit && getApplicationSource() === NPOS_APP);
};

/**
 * This function handles a case when a user is logged in TRUE EJ and tries to access native web EJ in same browser.
 * This will logout the user and get new token in case of TRUE platform.
 * This function checks if app is running on TRUE and if correct login token is available.
 * NPOS only supports retail login
 */
export const isValidTokenOrigin = () => {
  const appSource = getApplicationSource();
  const appAuthSource = getApplicationAuthSource();
  if ([TRUE_APP, NPOS_APP].includes(appSource)) {
    return (appAuthSource === RETAIL_AUTH || (appAuthSource === OKTA_AUTH && appSource === TRUE_APP));
  } else {
    return true;
  }
};

const TEST_ALLOWED_URLS = [
  'https://true-test.nike.com/', // RLP v1 test
  'https://rtl-lchpad-2.rbh-retail-launchpad-test.nikecloud.com/', // RLP Zero Trust test
  'https://rlp-test.nike.com/', // RLP Zero Trust test
  'https://rwe-core.retail-webux-test.nikecloud.com/', // RLP v2 test
  'http://localhost:3000/',
];

const PROD_ALLOWED_URLS = [
  'https://true.nike.com/', // RLP v1 prod
  'https://rtl-lchpad-2.rbh-retail-launchpad-prod.nikecloud.com/', // RLP Zero Trust prod
  'https://rlp.nike.com/', // RLP Zero Trust prod
  'https://rwe-core.retail-webux-prod.nikecloud.com/', // RLP v2 prod
];

// Helper to extract origin from URL (e.g., "https://true-test.nike.com/retailPrinting" -> "https://true-test.nike.com")
const getOriginFromUrl = (url) => {
  try {
    const parsed = new URL(url);
    return parsed.origin;
  } catch {
    return '';
  }
};

// Helper to check if referrer matches any allowed URL (by origin)
const matchesAllowedOrigin = (referrer, allowedUrls) => {
  const referrerOrigin = getOriginFromUrl(referrer);
  return allowedUrls.some((url) => getOriginFromUrl(url) === referrerOrigin);
};

export const getTargetOrigin = () => {
  const buildMode = (process.env.NODE_ENV || '').toLowerCase() || 'none';
  const referrerOrigin = getOriginFromUrl(document.referrer);

  if (buildMode === 'development') {
    return 'http://localhost:3000';
  }
  if (buildMode === 'test') {
    if (matchesAllowedOrigin(document.referrer, TEST_ALLOWED_URLS)) {
      return referrerOrigin;
    } else {
      return 'https://rlp-test.nike.com';
    }
  }

  if (buildMode === 'production') {
    if (matchesAllowedOrigin(document.referrer, PROD_ALLOWED_URLS)) {
      return referrerOrigin;
    } else {
      return 'https://rlp.nike.com';
    }
  }

  return 'http://localhost:3000';
};
